import React, { useState } from 'react'
import PropTypes from "prop-types"
import InfoliniaNumbers from "./infolinia-numbers"

Infolinia.propTypes = {
  customStyle: PropTypes.string,
}


function Infolinia({ customStyle }) {
  
  const [visible, setVisible] = useState(true)
  
    return (
      <div
        className={`infolinia  
        ${customStyle ? customStyle : ""} 
        ${visible ? "" : "show"}`}
      >
        <div
          className="info-logo"
          onClick={() => setVisible(!visible)}
          onKeyDown={() => setVisible(!visible)}
           tabIndex="0" role="button" aria-label="Pokaż"
        >
          <span className="icon-infolinia"></span>
        </div>
        <InfoliniaNumbers />
      </div>
    )
}

export default Infolinia
